import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component for adding JSON-LD structured data to pages
 * @param {Object} props - Component props
 * @param {string} props.type - Schema.org type (e.g., 'Organization', 'MedicalBusiness')
 * @param {Object} props.data - Structured data object
 */
const StructuredData = ({ type = 'Organization', data = {} }) => {
  // Default data for the organization
  const defaultOrganizationData = {
    '@context': 'https://schema.org',
    '@type': type,
    name: 'NuWav Laboratories',
    description: 'Clinical and molecular diagnostics including routine chemistry, hematology, immunology, urinalysis, and respiratory PCR (COVID-19, Influenza A/B, RSV). Also offering reagents and collection kits.',
    url: 'https://nuwavlabs.com',
    logo: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/4c8ad1cb-ca3b-458c-8639-a7d8f07a9bb6/08d356fd6b2751ca0a7c1b556012f0e4.png',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '2015 Midway Rd Bldg 111',
      addressLocality: 'Carrollton',
      addressRegion: 'TX',
      postalCode: '75006',
      addressCountry: 'US'
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+1-972-327-8857',
      contactType: 'customer service'
    }
  };

  // Merge default data with provided data
  const structuredData = { ...defaultOrganizationData, ...data };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData; 